const lang = {
  register: '会員登録',
  resetPassword: 'パスワード再設定',
  newPassword: '新しいパスワード設定',
  password: 'パスワード',
  passwordConfirm: 'パスワード再入力',
  settingCompleted: '設定完了',
  newPasswordSet: '新しいパスワードに設定されました。',
  passwordTip: '６～２０文字の半角の英数字または記号で入力してください。英字と数字の両方を含めてください。',
  passwordConfirmTip: '確認のため、もう１度同じパスワードを入力してください。',
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/resetPassword.js